/* 类型 */

export const SET_TOKEN = 'set_token'

export const SET_USERINFO = 'set_userinfo'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js